import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ArticlesStoreModule } from './articles-store/articles-store.module';
import { CommonStoreModule } from './common-store/common-store.module';
import { MachineLearningStoreModule } from './machine-learning-store/machine-learning-store.module';
import { MyModulesStoreModule } from './my-modules-store/my-modules-store.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, ArticlesStoreModule, CommonStoreModule, MyModulesStoreModule, MachineLearningStoreModule],
})
export class AppStoreModule {}
